export default class OldHelper {
  toOldHubUrl(url: string, path = '') {
    return `${url.startsWith('http') ? url : `https://${url}`}${path ? `&follow_link=${path}` : ''}`
  }
}
